export const SUBSTITUTE_TEACHER_STORE_NAME = 'SubstituteTeacherStore';

export enum API_VARIABLES {
  TYPE = '{type}',
  ORGANIZATION_ID = '{organizationId}',
  SUBSTITUTE_TEACHER_ID = '{substituteTeacherId}'
}

export const MUTATIONS = {
  SET_GIVEN_INVITATIONS_M:'setGivenInvitationsM',
  SET_RECEIVED_INVITATIONS_M:'setReceivedInvitationsM',
  RESET_TEACHER_INVITATIONS_M: 'resetTeacherInvitations'
}

export const ACTIONS = {
  GET_SUBSTITUTE_TEACHER_A:'getSubstituteTeacherA'
}

export const _SUBSTITUTE_TEACHER_STORE = {
  NAME: SUBSTITUTE_TEACHER_STORE_NAME,
  MUTATIONS: {
    SET_GIVEN_INVITATIONS_M: `${SUBSTITUTE_TEACHER_STORE_NAME}/${MUTATIONS.SET_GIVEN_INVITATIONS_M}`,
    SET_RECEIVED_INVITATIONS_M: `${SUBSTITUTE_TEACHER_STORE_NAME}/${MUTATIONS.SET_RECEIVED_INVITATIONS_M}`,
    RESET_TEACHER_INVITATIONS_M: `${SUBSTITUTE_TEACHER_STORE_NAME}/${MUTATIONS.RESET_TEACHER_INVITATIONS_M}`,
  },
  ACTIONS: {
    GET_SUBSTITUTE_TEACHER_A: `${SUBSTITUTE_TEACHER_STORE_NAME}/${ACTIONS.GET_SUBSTITUTE_TEACHER_A}`
  }
}

export const SUBSTITUTE_TEACHER_API = {
  GET_SUBSTITUTE_TEACHERS: 'substituteTeacher/{type}',
  CREATE_SUBSTITUTE_TEACHER: 'substituteTeacher/',
  GET_AVAILABLE_CLASSES: 'substituteTeacher/classes',
  UPDATE_DELETE_TEACHER_INVITATION: 'substituteTeacher/{substituteTeacherId}',
  ACCEPT_REJECT_TEACHER_INVITATION: 'substituteTeacher/acceptRejectInvitationPrivate/{substituteTeacherId}',
  GET_PENDING_RECEIVED_INVITATIONS: 'substituteTeacher/pendingReceived'
}

export const INVITATION_TYPE = {
  GIVEN: 'GIVEN',
  RECEIVED: 'RECEIVED'
}

export const INVITATION_STATUS = {
  INVITED: 'INVITED', 
  ACCEPTED: 'ACCEPTED', 
  REJECTED: 'REJECTED',
  REVOKED: 'REVOKED', 
  GRANTED: 'GRANTED'
}